// This import loads the firebase namespace along with all its type information.
import PlayerInvite from './player-invite-model'

export async function load_playerInvites(): Promise<PlayerInvite[]> {
  throw 'Not implemented'
}

export async function delete_playerInvite(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_playerInvite(): Promise<PlayerInvite> {
  throw 'Not implemented'
}
